import Component from '../core/Component'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-active',
}

export default class NavDots extends Component {
    prepare() {
        EventBus.on('nav:change', this.handleNavChange)
    }

    handleNavChange = ({ status }) => {
        this.element.classList.toggle(STATES.ACTIVE, status)
    }
}
